(function () {
  'use strict';
  var site = document.querySelector('[data-vemro-site]');
  if (!site) return;
  var clientModal = document.getElementById('vemro-client-modal');
  var proModal = document.getElementById('vemro-pro-modal');
  var clientForm = document.getElementById('vemro-client-form');
  var lastActive;
  var selectedService = 'Limpieza a domicilio';
  var selectedMode = 'Asignación por VEMRO';
  var selectedProvider = '';
  var selectedProviderId = '';
  function availableServices() {
    var items = document.querySelectorAll('[data-service-option]');
    var data = [];
    items.forEach(function (el) {
      var value = (el.getAttribute('data-service-name') || '').trim();
      if (!value) return;
      if (!data.some(function (v) { return v.value === value; })) data.push({value:value, available: el.getAttribute('data-service-available') === 'true'});
    });
    if (!data.length) data.push({value:'Limpieza a domicilio', available:true});
    return data;
  }
  function refreshServices() {
    var services = availableServices();
    document.querySelectorAll('[data-service-select],[data-request-service]').forEach(function (select) {
      var prior = select.value;
      while (select.firstChild) select.removeChild(select.firstChild);
      services.forEach(function (service) {
        var option = document.createElement('option');
        option.value = service.value;
        option.textContent = service.value + (service.available ? '' : ' — próximamente');
        option.disabled = !service.available;
        select.appendChild(option);
      });
      var first = services.find(function (v) { return v.available; });
      if (first) select.value = services.some(function (v) {return v.value===prior && v.available;}) ? prior : first.value;
    });
  }
  function openModal(modal) {
    if (!modal) return;
    lastActive = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('modal-open');
    var input = modal.querySelector('input:not([type=hidden]),button');
    if (input) input.focus();
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    if (document.querySelectorAll('.modal:not([hidden])').length === 0) document.body.classList.remove('modal-open');
    if (lastActive && lastActive.focus) lastActive.focus();
  }
  function requestFromButton(button) {
    var wanted = button.getAttribute('data-service-name-button') || '';
    var selectorId = button.getAttribute('data-service-from');
    var selector = selectorId ? document.getElementById(selectorId) : null;
    if (selector && selector.value) wanted = selector.value;
    var chosen = button.getAttribute('data-assignment') === 'elegido';
    selectedProvider = chosen ? (button.getAttribute('data-provider-name') || '') : '';
    selectedProviderId = chosen ? (button.getAttribute('data-provider-id') || '') : '';
    selectedMode = selectedProvider ? 'Prestador elegido' : 'Asignación por VEMRO';
    refreshServices();
    var serviceSelect = document.querySelector('[data-request-service]');
    if (serviceSelect) {
      if (wanted && !Array.prototype.some.call(serviceSelect.options, function(o){return o.value === wanted && !o.disabled;})) {
        var extra = document.createElement('option'); extra.value = wanted; extra.textContent = wanted; serviceSelect.appendChild(extra);
      }
      if (wanted) serviceSelect.value = wanted;
      selectedService = serviceSelect.value;
    }
    if (clientForm) {
      clientForm.querySelector('[data-mode-field]').value = selectedMode;
      clientForm.querySelector('[data-provider-field]').value = selectedProvider;
      clientForm.querySelector('[data-provider-id-field]').value = selectedProviderId;
      var notice = clientModal.querySelector('[data-request-mode-text]');
      if (notice) notice.textContent = selectedProvider
        ? 'Solicitarás a ' + selectedProvider + '. Confirmaremos la disponibilidad antes de reservar.'
        : 'VEMRO buscará un profesional disponible según tu solicitud.';
    }
    openModal(clientModal);
  }
  document.addEventListener('click', function (event) {
    var requestButton = event.target.closest('[data-open-request]');
    if (requestButton) { event.preventDefault(); requestFromButton(requestButton); return; }
    var applyButton = event.target.closest('[data-open-apply]');
    if (applyButton) { event.preventDefault(); openModal(proModal); return; }
    var closeButton = event.target.closest('[data-close-modal]');
    if (closeButton) { closeModal(closeButton.closest('.modal')); return; }
    if (event.target.classList && event.target.classList.contains('modal')) closeModal(event.target);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') document.querySelectorAll('.modal:not([hidden])').forEach(closeModal);
  });
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-provider-filter]')) return;
    var filter = event.target;
    var directory = filter.closest('.provider-directory');
    if (!directory) return;
    var shown = 0;
    directory.querySelectorAll('[data-provider-card]').forEach(function (card) {
      var area = (card.getAttribute('data-commune') || '').toLowerCase();
      var match = filter.value === 'todos' || area.indexOf(filter.value) !== -1;
      card.hidden = !match;
      if (match) shown++;
    });
    var noResults = directory.querySelector('[data-provider-filter-empty]');
    if (noResults) noResults.hidden = shown !== 0;
  });
  function contactMessage(form) {
    var get = function(id){ var element = document.getElementById(id); return element ? (element.value || '').trim() : ''; };
    return [
      'Hola, quiero solicitar un servicio a VEMRO.',
      'Nombre: ' + get('v-nombre'), 'Correo: ' + get('v-email'), 'Teléfono: ' + get('v-phone'),
      'Servicio: ' + get('v-servicio'), 'Modalidad: ' + selectedMode,
      selectedProvider ? 'Prestador solicitado: ' + selectedProvider : '',
      selectedProviderId ? 'Referencia de perfil: ' + selectedProviderId : '',
      'Comuna: ' + get('v-comuna'), 'Sector: ' + get('v-sector'),
      'Fecha preferida: ' + get('v-fecha'), 'Horario: ' + get('v-hora'),
      'Detalles: ' + get('v-detalle'), 'Quisiera confirmar precio y disponibilidad.'
    ].filter(Boolean).join('\n');
  }
  if (clientForm) clientForm.addEventListener('submit',function (ev) {
    if (!clientForm.reportValidity()) { ev.preventDefault(); return; }
    var message = contactMessage(clientForm);
    var body = clientForm.querySelector('[data-contact-body]');
    if (body) body.value = message;
    var channel = site.getAttribute('data-booking-channel') || 'email';
    var phone = (site.getAttribute('data-whatsapp-number') || '').replace(/\D/g,'');
    if (channel === 'whatsapp' && /^\d{10,15}$/.test(phone)) {
      ev.preventDefault();
      var url = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
      var link = document.createElement('a');
      link.href = url; link.target = '_blank'; link.rel='noopener noreferrer';
      document.body.appendChild(link); link.click(); link.remove();
    }
    // Modo correo, o WhatsApp sin número: el formulario Shopify Contact se envía nativamente.
    try { sessionStorage.setItem('vemro_last_contact', 'client'); } catch (e) {}
  });
  var applicationForm = document.getElementById('vemro-professional-form');
  if (applicationForm) applicationForm.addEventListener('submit', function () {
    try { sessionStorage.setItem('vemro_last_contact', 'professional'); } catch (e) {}
  });
  var resultForm = '';
  try { resultForm = sessionStorage.getItem('vemro_last_contact') || ''; } catch (e) {}
  var clientResult = clientModal && clientModal.querySelector('[data-client-success],[data-client-error]');
  var proResult = proModal && proModal.querySelector('[data-apply-success],[data-apply-error]');
  if (resultForm === 'professional' && proResult) openModal(proModal);
  else if (resultForm === 'client' && clientResult) openModal(clientModal);
  else if (clientResult) openModal(clientModal);
  else if (proResult) openModal(proModal);
  if (clientResult || proResult) try { sessionStorage.removeItem('vemro_last_contact'); } catch (e) {}
  refreshServices();
  document.addEventListener('shopify:section:load', refreshServices);
  document.addEventListener('shopify:block:select', function (ev) {
    var block = ev.target;
    if (block && block.matches && block.matches('[data-provider-card]')) block.scrollIntoView({block:'center',behavior:'smooth'});
  });
})();
